import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import AccountDetail from './pages/AccountDetail';
import CreateAccount from './pages/CreateAccount';
import Products from './pages/Products';
import CreateSalesCall from './pages/CreateSalesCall';
import CreateTelephonicCall from './pages/CreateTelephonicCall';
import CallHistory from './pages/CallHistory';
import UserManagement from './pages/UserManagement';
import ChangePassword from './pages/ChangePassword';
import AssignAccounts from './pages/AssignAccounts';
import BulkEditAccounts from './pages/BulkEditAccounts';
import Approvals from './pages/Approvals';
import Documents from './pages/Documents';
import ShareDocument from './pages/ShareDocument';
import Leads from './pages/Leads';
import ActionLog from './pages/ActionLog';
import ScheduledCalls from './pages/ScheduledCalls';
import { Toaster } from './components/ui/sonner';
import '@/App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const adminStatus = localStorage.getItem('isAdmin') === 'true';
    setIsAuthenticated(!!token);
    setIsAdmin(adminStatus);
    setIsLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userData.user_id);
    localStorage.setItem('userName', userData.name);
    localStorage.setItem('userEmail', userData.email);
    localStorage.setItem('isAdmin', userData.is_admin.toString());
    setIsAuthenticated(true);
    setIsAdmin(userData.is_admin);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('isAdmin');
    setIsAuthenticated(false);
    setIsAdmin(false);
  };

  if (isLoading) {
    return <div className="min-h-screen bg-slate-50 flex items-center justify-center">Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />}
          />
          <Route
            path="/dashboard"
            element={isAuthenticated ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/accounts"
            element={isAuthenticated ? <Accounts onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/accounts/new"
            element={isAuthenticated ? <CreateAccount onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/accounts/:accountId"
            element={isAuthenticated ? <AccountDetail onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/products"
            element={isAuthenticated ? <Products onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/leads"
            element={isAuthenticated ? <Leads onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/action-log"
            element={isAuthenticated ? <ActionLog onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/calls/telephonic"
            element={isAuthenticated ? <CreateTelephonicCall onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/calls/new"
            element={isAuthenticated ? <CreateSalesCall onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/calls/history"
            element={isAuthenticated ? <CallHistory onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/users"
            element={isAuthenticated && isAdmin ? <UserManagement onLogout={handleLogout} /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/documents"
            element={isAuthenticated ? <Documents onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/documents/share"
            element={isAuthenticated ? <ShareDocument onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/scheduled-calls"
            element={isAuthenticated ? <ScheduledCalls onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/approvals"
            element={isAuthenticated && isAdmin ? <Approvals onLogout={handleLogout} /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/accounts/bulk-edit"
            element={isAuthenticated ? <BulkEditAccounts onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/assign-accounts"
            element={isAuthenticated && isAdmin ? <AssignAccounts onLogout={handleLogout} /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/change-password"
            element={isAuthenticated ? <ChangePassword onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
